import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()
export const apEnrichment = async (all_ids: string[], email: boolean, path: string): Promise<string> => {
    try {
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/ap/enrichment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify({
                all_ids: all_ids,
                email: email,
                path: path
            })
        });
        const data = await response.json();
        return JSON.parse(data.body);
    } catch (error) {
        console.error('Error fetching files:', error);
        return '';
    }
};